require('dotenv').config()

const Thmesev ="v92" 

export default Thmesev;
